import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable, of } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { SiteGroup } from '@classes/site-group';

@Injectable({
  providedIn: 'root'
})
export class SiteGroupsService {
    siteGroupsListChanged = new Subject<SiteGroup[]>();
    private baseUrl: string = environment.apiUrl + 'site-groups';
    private siteGroups: SiteGroup[];

    constructor(
        private http: HttpClient
    ) { }

    getList(): Observable<SiteGroup[]> {
        return this.http.get<SiteGroup[]>(this.baseUrl)
        .pipe(
            map(siteGroups => {
                this.siteGroups = siteGroups.map(g => SiteGroup.fromObject(g));
                this.siteGroups.sort((a, b) => a.name.localeCompare(b.name));
                this.siteGroupsListChanged.next([ ...this.siteGroups ]);
                return [ ...this.siteGroups ];
            })
        );
    }

    put(siteGroup: SiteGroup): Observable<SiteGroup> {
        return this.http.put<SiteGroup>(this.baseUrl, siteGroup)
        .pipe(
            tap(editedSiteGroup => {
                editedSiteGroup = SiteGroup.fromObject(editedSiteGroup);
                this.siteGroups = this.siteGroups.map(g => g.id === editedSiteGroup.id ? editedSiteGroup : g);
                this.siteGroupsListChanged.next([ ...this.siteGroups ]);
            })
        );
    }

    post(siteGroup: SiteGroup): Observable<SiteGroup> {
        return this.http.post<SiteGroup>(this.baseUrl, siteGroup)
        .pipe(
            tap(createdSiteGroup => {
                createdSiteGroup = SiteGroup.fromObject(createdSiteGroup);
                this.siteGroups.push(createdSiteGroup);
                this.siteGroupsListChanged.next([ ...this.siteGroups ]);
            })
        );
    }

    delete(id: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${id}`)
        .pipe(
            tap(() => {
                this.siteGroups = this.siteGroups.filter(g => g.id !== id);
                this.siteGroupsListChanged.next([ ...this.siteGroups ]);
            })
        );
    }
}
